<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { get } from 'svelte/store';

    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import { onMount } from 'svelte';
    import { currentMainFilter } from '../../../stores/filter';
    import {
        debug,
        mainMenu,
        tacticalPlanRuleCurrent,
        tacticalPlanStore,
    } from '../../../stores/store';
    import TacticalPlanOne from './TacticalPlanOne.svelte';
    import IconBack from '../../shared/Icons/IconBack.svelte';
    import InputTextInline from '../../shared/InputTextInline.svelte';
    import { TacticalPlanApi } from './TacticalPlanApi';
    import { api } from '../../../stores/api';
    import { tacticalPlanName } from '../../../stores/store';
    import TemplateHeaderUno from '../../shared/TemplateHeaderUno.svelte';
    import { waitForZoneSave } from './waitForZoneSave';
    import { Navigation } from '../../utilities/Navigation';
    import ErrorInline from '../../shared/ErrorInline.svelte';

    export let id: number; // | 'new' = 'new';

    $tacticalPlanName = '';

    async function setTacticalPlanName(id: number, name: string) {
        console.log('setTacticalPlanName', id, name);
        await TacticalPlanApi.updateName(get(api), id, name);
    }

    function beforeUnload(event: BeforeUnloadEvent) {
        waitForZoneSave(() => {
            console.log('tactical-plan-one - beforeUnload');
            // event.preventDefault();
            // event.returnValue = '';
        });
    }

    onMount(() => {
        $mainMenu.currentPage = 'PageTacticalPlan';
        $currentMainFilter = null;
        Navigation.addListener('tactical-plan-one', () => {
            return new Promise((resolve, reject) => {
                waitForZoneSave(() => {
                    resolve(true);
                });
            });
        });
        return () => {
            $currentMainFilter = null;
            Navigation.removeListener('tactical-plan-one');
        };
    });
</script>

<svelte:window on:beforeunload={beforeUnload} />

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderUno>
            <div slot="main-header">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                    <div style="display: flex; align-items: center;min-height: 36px;">
                        <IconBack
                            scale={0.7}
                            on:click={() => {
                                Navigation.doSomething(() => {
                                    $tacticalPlanStore.forceReload = true;
                                    Navigation.navigate('/tactical-plan');
                                    // window.history.back();
                                });
                            }}
                        />
                        {$_('Tactical plan')}:&nbsp;
                        <span style="color: #1c5dc7">
                            <InputTextInline
                                bind:value={$tacticalPlanName}
                                onChange={value => {
                                    console.log('text', value);
                                    setTacticalPlanName(id, value);
                                }}
                            />
                        </span>
                    </div>
                    <div>
                        {#if $debug}
                            currentRuleId: {$tacticalPlanRuleCurrent}
                            <!--{JSON.stringify($tacticalPlanStore)}-->
                        {/if}
                    </div>
                </div>
            </div>
        </TemplateHeaderUno>
    </div>
    <div slot="content-header">
        {#if $tacticalPlanStore.countedErrors > 0}
            <div style="padding: 3px 0 0 15px;font-size:14px;">
                <ErrorInline
                    text={'(' + $_('Errors') + ': ' + $tacticalPlanStore.countedErrors + ')'}
                />
                <!--                        <ErrorColor>-->
                <!--                            ({$_('Errors')}: {$tacticalPlanStore.countedErrors})-->
                <!--                        </ErrorColor>-->
            </div>
        {/if}
    </div>
    <div slot="content">
        <TacticalPlanOne {id} />
    </div>
</TemplateStandard>

<style>
</style>
